<template>
  <div v-if="path">
    <div class="row">
      <div class="col-4">
        <label
          v-tooltip="uniToolTipTranslation('S712', 'en-US')"
          class="label-unidato manifoldSelectLabel"
          >{{ uniTranslation("S712") }}</label
        >
        <!-- {{uniTranslation('S572')}} -->
      </div>
      <div class="col-8">
        <el-select
          v-model="selectedManifoldCalculationType"
          class="manifoldSelect"
          placeholder="..."
          filterable
        >
          <el-option
            v-for="item in manifoldCalculationTypeList"
            :key="item.id"
            v-tooltip="uniToolTipTranslation(item.description, 'en-US')"
            :label="uniTranslation(item.description)"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>

    <div v-show="selectedManifoldCalculationType > 0" class="row">
      <div class="col-12">
        <MaterialPicker
          :parent-path="path"
          :name="'.manifold.material.id'"
          :tags="'.manifold.material.tags'"
        ></MaterialPicker>
      </div>
    </div>

    <!--<div class="col-4">
        <label class="label-unidato manifoldSelectLabel">In</label>
      </div>
      <div class="col-8">
        
    </div>-->
    <ManifoldPicker
      v-show="selectedManifoldCalculationType == 1 || selectionDone == true"
      :parent-path="path"
      :label="'S2034'"
      :name="'.manifold.inlet.idCollettore'"
      :tags="'.manifold.material.tags'"
      :material-id="manifoldMaterialId"
      :is-disabled="selectedManifoldCalculationType == 2 || selectedManifoldCalculationType == 0"
    ></ManifoldPicker>

    <ManifoldPicker
      v-show="selectedManifoldCalculationType == 1 || selectionDone == true"
      :parent-path="path"
      :label="'S2036'"
      :name="'.manifold.outlet.idCollettore'"
      :tags="'.manifold.material.tags'"
      :material-id="manifoldMaterialId"
      :is-disabled="selectedManifoldCalculationType == 2 || selectedManifoldCalculationType == 0"
    ></ManifoldPicker>

    <div v-show="selectedManifoldCalculationType > 0" class="row">
      <div class="col-4">
        <label
          v-tooltip="uniToolTipTranslation('S2056', 'en-US')"
          class="label-unidato manifoldSelectLabel"
          >{{ uniTranslation("S2056") }}</label
        >
      </div>
      <div class="col-8">
        <el-select
          v-model="selectedManifoldDisposition"
          class="manifoldSelect"
          placeholder="..."
          filterable
        >
          <el-option
            v-for="item in manifoldDispositionList"
            :key="item.id"
            v-tooltip="uniToolTipTranslation(item.description, 'en-US')"
            :label="uniTranslation(item.description)"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>

    <div v-show="selectedManifoldCalculationType > 0" class="row">
      <div class="col-4">
        <label
          v-tooltip="uniToolTipTranslation('S450', 'en-US')"
          class="label-unidato manifoldSelectLabel"
          >{{ uniTranslation("S450") }}</label
        >
      </div>
      <div class="col-8">
        <el-select
          v-model="selectedManifoldCouples"
          class="manifoldSelect"
          placeholder="..."
          filterable
        >
          <el-option
            v-for="item in manifoldCouplesList"
            :key="item.id"
            :label="item.descrizione"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Select, Option } from "element-ui";
import manifoldService from "../../services/backend/manifoldService";
import jsonHelper from "../../shared/jsonHelper";
import MaterialPicker from "../shared/MaterialPicker";
import ManifoldPicker from "../shared/ManifoldPicker";

export default {
  components: {
    "el-select": Select,
    "el-option": Option,
    MaterialPicker,
    ManifoldPicker
  },
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      manifoldCalculationTypeList: [],
      selectedManifoldCalculationType: "",
      manifoldDispositionList: [],
      selectedManifoldDisposition: "",
      manifoldCouplesList: [],
      selectedManifoldCouples: "",
      manifoldMaterialId: 0,
      selectionDone: false
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    selectedManifoldCalculationType: function(nv /*, ov*/) {
      if (nv != null && nv != undefined) {
        this.selectionDone = false;
        var idg = parseInt(nv);
        this.$store.dispatch("changeProjectProperty", {
          path: this.path + ".manifold.calculationType",
          value: idg
        });
      }
    },
    selectedManifoldCouples: function(nv /*, ov*/) {
      if (nv != null && nv != undefined) {
        this.selectionDone = false;
        var idg = parseInt(nv);
        this.$store.dispatch("changeProjectProperty", {
          path: this.path + ".manifold.couples",
          value: idg
        });
      }
    }
  },
  mounted: function() {
    var that = this;
    that.$nextTick(function() {
      manifoldService.getCalculationTypes().then(function(data) {
        data.forEach(element => {
          that.manifoldCalculationTypeList.push({
            description: element.description,
            id: element.id
          });
        });
        that.selectedManifoldCalculationType = jsonHelper.getProperty(
          that.projects,
          that.path + ".manifold.calculationType"
        );
      });

      manifoldService.getDispositionTypes().then(function(data) {
        data.forEach(element => {
          that.manifoldDispositionList.push({
            description: element.description,
            id: element.id
          });
        });
        that.selectedManifoldDisposition = jsonHelper.getProperty(
          that.projects,
          that.path + ".manifold.disposition"
        );
      });

      that.manifoldCouplesList.push({
        descrizione: "1",
        id: 1
      });

      that.manifoldCouplesList.push({
        descrizione: "2",
        id: 2
      });

      that.manifoldCouplesList.push({
        descrizione: "3",
        id: 3
      });

      that.selectedManifoldCouples = jsonHelper.getProperty(
        that.projects,
        that.path + ".manifold.couples"
      );

      that.manifoldMaterialId = 2;

      that.$store.subscribe(function(mutation /*, state*/) {
        if (mutation.type === "refreshAll") {
          let path = that.path + ".manifold.selectionDone";
          let myObj = jsonHelper.getProperty(that.projects, path);
          that.selectionDone = myObj;
        }
      });

      that.$store.subscribe(function(mutation /*, state*/) {
        let path = that.path + ".manifold.material.id";
        if (mutation.type === "changeProjectProperty") {
          if (mutation.payload.path.startsWith(path)) {
            var idMat = mutation.payload.value;
            that.manifoldMaterialId = idMat;
            if (that.selectedManifoldCalculationType == 2) that.selectionDone = false;
          }
        }
      });
    });
  },
  methods: {}
};
</script>

<style lang="scss">
.manifoldSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.manifoldSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px;
    }
  }
}

.manifoldSelectRow {
  margin-right: 0px;
  margin-left: 0px;
  .col-3 {
    padding-right: 0px;
    padding-left: 0px;
  }
  .col-9 {
    padding-right: 0px;
    padding-left: 0px;
  }
}
</style>
